import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEmploymentStatusPage = {
  alert: {
    error: 'coapplicant-employment-status-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-employment-status-page.footer.root',
  },
  form: {
    h1: 'coapplicant-employment-status-page.form.h1',
    h2: 'coapplicant-employment-status-page.form.h2',
    radioGroupRoot: 'coapplicant-employment-status-page.form.radio-group-root',
    radioOption1: 'coapplicant-employment-status-page.form.radio-option-1',
    radioOption2: 'coapplicant-employment-status-page.form.radio-option-2',
    root: 'coapplicant-employment-status-page.form.root',
    submitButton: 'coapplicant-employment-status-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
